import {SketchRelationKind} from '../../../../sketch/solver/constraint/relation-compatibility';
import {SingleTargetRelation} from '../../../../sketch/solver/constraint/relationDefinition/SingleTargetRelation';
import type {AbstractSketchEdgeObject} from '../../../../mesh/sketch/AbstractSketchEdgeObject';
import {resolvePreferredEdgeLabel} from '../../model/EdgeLabelUtils';

/**
 * 转换实体引用失效后的诊断关系。
 *
 * 该关系不保存几何载荷，也不参与求解；它只把引用记录中的悬空状态投影为
 * SolidWorks 风格的“在边线上（On Edge）”关系警告。来源恢复或引用删除后，
 * 诊断投影服务会移除该实例。
 */
export class DanglingSketchEntityReferenceConstraint
	extends SingleTargetRelation<AbstractSketchEdgeObject> {
	/** 标记该关系只属于派生诊断，不得进入实体复制结果。 */
	public override readonly isTransientDiagnosticConstraint = true;
	/** 引用记录稳定 ID。 */
	public readonly referenceId: string;
	/** 转换实体引用在关系面板中的统一语义。 */
	public relationType = SketchRelationKind.OnEdge;

	/**
	 * @param referenceId 引用记录稳定 ID。
	 * @param diagnosticMessage 当前悬空原因。
	 * @param sourceDisplayLabel 持久化来源显示标签。
	 */
	public constructor(
		referenceId: string,
		diagnosticMessage: string,
		sourceDisplayLabel?: string,
	) {
		super();
		this.referenceId = referenceId;
		this.name = resolvePreferredEdgeLabel({
			persistedSourceDisplayLabel: sourceDisplayLabel,
		});
		this.markDangling(diagnosticMessage);
	}

	/** @returns 关系面板使用的稳定显示名。 */
	public override get baseDisplayName(): string {
		return this.name;
	}
}
